module.exports = __webpack_public_path__ + "img/HS.551e367d.png";